import { render, staticRenderFns } from "./AccountKidsDuplicate.vue?vue&type=template&id=7981430b&scoped=true"
import script from "./AccountKidsDuplicate.vue?vue&type=script&lang=js"
export * from "./AccountKidsDuplicate.vue?vue&type=script&lang=js"
import style0 from "./AccountKidsDuplicate.vue?vue&type=style&index=0&id=7981430b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7981430b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7981430b')) {
      api.createRecord('7981430b', component.options)
    } else {
      api.reload('7981430b', component.options)
    }
    module.hot.accept("./AccountKidsDuplicate.vue?vue&type=template&id=7981430b&scoped=true", function () {
      api.rerender('7981430b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/AccountKidsDuplicate.vue"
export default component.exports